import { DateInputFormat, handleRawDate } from "@/components/common/DateComponents";
import { addMonths, format, parse } from "date-fns";
import ReactDatePicker from "react-datepicker";
import { connect } from "react-redux";
import Tooltip from "@/tooltip";

const UpdateDepartment = ({ updateField, data, engagementDate, enrolmentDeferredUntil }) => {
	const deferredUntil = data.enrolmentDeferredUntil;

	const existingData =
		typeof deferredUntil === "string" ? parse(deferredUntil, "yyyy-MM-dd", new Date()) : deferredUntil;

	const selected = typeof existingData !== "undefined" ? existingData : enrolmentDeferredUntil;

	return (
		<>
			<div className="col-xs-8">
				<div className="form-material">
					<ReactDatePicker
						autoComplete="off"
						dateFormat="dd MMM yyyy"
						minDate={engagementDate}
						maxDate={addMonths(engagementDate, 3)}
						wrapperClassName="full-width"
						customInput={<DateInputFormat />}
						className="form-control form-input"
						onChange={(date) => {
							updateField("enrolmentDeferredUntil", date ? format(date, "yyyy-MM-dd") : false);
						}}
						onChangeRaw={(e) => {
							handleRawDate(e.target.value, (date) => {
								updateField("enrolmentDeferredUntil", date ? format(date, "yyyy-MM-dd") : false);
							});
						}}
						strictParsing
						isClearable
						selected={selected}
					/>
					<label htmlFor="enrolmentDeferredUntil">
						<Tooltip
							content={
								"You can choose to delay working out which pension scheme they are enrolled in for up to three months after their engagement date"
							}
						>
							Postpone Auto Enrolment
						</Tooltip>
					</label>
				</div>
			</div>
			{selected ? (
				<div className="col-xs-4">
					<button
						className="btn btn-xs btn-danger"
						type="button"
						style={{ marginTop: 15 }}
						onClick={() => updateField("enrolmentDeferredUntil", false)}
					>
						Remove
					</button>
				</div>
			) : null}
		</>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { agreementInfo } = state.employee || {};
	const { engagementDate, enrolmentDeferredUntil } = agreementInfo || {};

	return {
		engagementDate: parse(engagementDate, "yyyy-MM-dd", new Date()),
		enrolmentDeferredUntil: enrolmentDeferredUntil ? parse(enrolmentDeferredUntil, "yyyy-MM-dd", new Date()) : null,
	};
};
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDepartment);
